export default {
  ACTIVE: 'ACTIVE',
  AWARDED: 'AWARDED',
  ACCEPTED: 'ACCEPTED',
  IGNORED: 'IGNORED',
  NEGOTIATED: 'NEGOTIATED',
};
